// extracted by mini-css-extract-plugin
module.exports = {"rootSizeOverlay":"_1czT_","desktop":"_2Sgdj","mobile":"_1JRCu","rootSizeOverlayDesc":"_2ydgP","overlayDescription":"_1ADZa"};